import { cn } from '@/lib/utils'

export type ButtonVariant = 'primary' | 'dark' | 'outline' | 'outline-light' | 'light'

export type ButtonSize = 'sm' | 'md' | 'lg'

interface ButtonStyleOptions {
    variant?: ButtonVariant
    size?: ButtonSize
    className?: string
}

const base = 'group/button inline-flex items-center justify-center gap-2 rounded-full font-semibold tracking-[0.01em] whitespace-nowrap transition-[background-color,color,border-color,box-shadow,translate] duration-300 ease-out hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-orange focus-visible:ring-offset-2 focus-visible:ring-offset-brand-white disabled:pointer-events-none disabled:opacity-60'

const variants: Record<ButtonVariant, string> = {
    primary: 'bg-brand-orange text-brand-charcoal shadow-[0_14px_30px_-14px_rgba(232,121,50,0.9)] hover:bg-brand-orange-light',
    dark: 'bg-brand-charcoal text-brand-white shadow-[0_14px_30px_-16px_rgba(32,32,32,0.9)] hover:bg-brand-ink',
    outline: 'border border-brand-charcoal/25 text-brand-charcoal hover:border-brand-charcoal hover:bg-brand-charcoal hover:text-brand-white',
    'outline-light': 'border border-brand-white/35 text-brand-white hover:border-brand-white hover:bg-brand-white hover:text-brand-charcoal',
    light: 'bg-brand-white text-brand-charcoal hover:bg-brand-cream'
}

const sizes: Record<ButtonSize, string> = {
    sm: 'h-10 px-4 text-[13px]',
    md: 'h-12 px-6 text-sm',
    lg: 'h-14 px-8 text-[15px]'
}

export const buttonStyles = ({ variant = 'primary', size = 'md', className }: ButtonStyleOptions = {}): string => {
    return cn(base, variants[variant], sizes[size], className)
}
